<div *ngIf="isLoading else handoverTemp" class="grid place-items-center w-full h-full ">
  <div class="w-full grid place-items-center">
    <mat-spinner [strokeWidth]="2" [diameter]="48"></mat-spinner>
    <div class="font-semibold mt-4">{{'labels.loading-data' | translate}}</div>
  </div>
</div>

<ng-template #handoverTemp>
  <div class="grid bg-white">
    <handoverm-handover-menu *ngIf="!isPrintMode" [model]="model"></handoverm-handover-menu>
    <div
      [ngClass]="{ 
        'overflow-auto no-print-height protocol-wrapper': !isPrintMode
      }"
      class="px-6 py-10 flex flex-col w-full tk-print-color-adjust-exact"
    >
      <handoverm-handover-top-label [model]="model"></handoverm-handover-top-label>
      <handoverm-handover-header [model]="model"
                                 [fromOrToDriverTrans]="fromOrToDriverTrans"></handoverm-handover-header>
      <handoverm-handover-equipment [model]="model"></handoverm-handover-equipment>
      <handoverm-handover-general [model]="model"></handoverm-handover-general>
      <handoverm-handover-damages [model]="model"></handoverm-handover-damages>
      <handoverm-handover-comments [model]="model"></handoverm-handover-comments>
      <handoverm-handover-statement [model]="model"></handoverm-handover-statement>
      <handoverm-handover-signature class="break-inside-avoid" [model]="model"></handoverm-handover-signature>
      <handoverm-handover-bottom-label [model]="model"></handoverm-handover-bottom-label>
    </div>
  </div>
</ng-template>
